<header class="showcase-header">
  <h1 class="gn-headline-xs-bold">GetNet Design System</h1>
  <p class="gn-body-sm-regular">
    Componentes Celero com a camada custom GetNet (Samba Web V.3.0).
  </p>
</header>

<section data-family="buttons">
  <h2 class="gn-headline-xs-bold">Buttons &amp; Actions</h2>

  <div class="row">
    <button class="cds-button s-solid c-primary gn-size-s" type="button">Small</button>
    <button class="cds-button s-solid c-primary gn-size-m" type="button">Medium</button>
    <button class="cds-button s-solid c-primary gn-size-l" type="button">Large</button>
    <button class="cds-button s-solid c-primary gn-size-m" type="button" disabled>Disabled</button>
  </div>

  <div class="row">
    <button class="cds-button s-hollow c-primary gn-size-m" type="button">Secondary</button>
    <button class="cds-button s-hollow c-primary gn-size-m" type="button" disabled>Secondary disabled</button>
    <button class="cds-button v-underlined c-primary gn-size-m" type="button">Text button</button>
  </div>

  <div class="row">
    <button class="cds-button s-solid c-danger gn-size-m" type="button">Danger</button>
    <button class="cds-button s-solid c-secondary gn-size-m" type="button">Alternative</button>
  </div>
</section>

<section data-family="datainput">
  <h2 class="gn-headline-xs-bold">Data input &amp; Selection</h2>

  <fieldset>
    <label class="gn-body-sm-bold">Campo de texto</label>
    <input type="text" class="cds-form-field" placeholder="Digite algo">
  </fieldset>

  <fieldset>
    <label class="gn-body-sm-bold">Campo desabilitado</label>
    <input type="text" class="cds-form-field" placeholder="Indisponível" disabled>
  </fieldset>

  <section class="cds-input-wrapper">
    <input class="cds-radio" type="radio" name="showcase-radio" id="showcase-radio">
    <label for="showcase-radio" class="gn-body-sm-regular">Radio</label>
  </section>

  <section class="cds-input-wrapper">
    <input class="cds-checkbox" type="checkbox" id="showcase-checkbox">
    <label for="showcase-checkbox" class="gn-body-sm-regular">Checkbox</label>
  </section>

  <fieldset>
    <label class="gn-body-sm-bold">Dropdown</label>
    <cds-dropdown [options]="['Opção 1', 'Opção 2', 'Opção 3']" />
  </fieldset>

  <fieldset>
    <label class="gn-body-sm-bold">Datepicker</label>
    <cds-datepicker placeholder="DD/MM/AAAA" />
  </fieldset>
</section>

<section data-family="feedback">
  <h2 class="gn-headline-xs-bold">Feedback &amp; System status</h2>

  <div class="row">
    <div class="feedback feedback--error">
      <span class="feedback-title gn-body-sm-bold">Erro</span>
      <span class="gn-body-sm-regular">Não foi possível concluir a operação.</span>
    </div>
    <div class="feedback feedback--warning">
      <span class="feedback-title gn-body-sm-bold">Atenção</span>
      <span class="gn-body-sm-regular">Revise os dados antes de continuar.</span>
    </div>
    <div class="feedback feedback--success">
      <span class="feedback-title gn-body-sm-bold">Sucesso</span>
      <span class="gn-body-sm-regular">Operação concluída.</span>
    </div>
    <div class="feedback feedback--info">
      <span class="feedback-title gn-body-sm-bold">Informação</span>
      <span class="gn-body-sm-regular">Este é um ambiente de demonstração.</span>
    </div>
  </div>

  <div class="row">
    <i class="cds-icon-calendar" [cdsTooltip]="'Tooltip GetNet'" placement="top"></i>
  </div>
</section>

<section data-family="indicators">
  <h2 class="gn-headline-xs-bold">Indicators</h2>

  <div class="row">
    <span class="label label--grey gn-body-xs-bold">Neutro</span>
    <span class="label label--green gn-body-xs-bold">Aprovado</span>
    <span class="label label--red gn-body-xs-bold">Recusado</span>
    <span class="label label--yellow gn-body-xs-bold">Pendente</span>
    <span class="label label--turquoise gn-body-xs-bold">Em processo</span>
    <span class="label label--lighter-blue gn-body-xs-bold">Em análise</span>
    <span class="label label--light-blue gn-body-xs-bold">Informativo</span>
  </div>
</section>

<section data-family="info-card">
  <h2 class="gn-headline-xs-bold">Info card</h2>

  <p class="gn-body-sm-regular">
    Carrossel de avisos do Dashboard. Com dois ou mais avisos ele alterna sozinho a cada
    4,6s, pausa com o ponteiro em cima e os dots levam direto ao aviso. Com um aviso só
    fica estático, sem dots.
  </p>

  <div class="row">
    <info-card [notices]="infoNotices" />
  </div>

  <p class="gn-body-sm-regular">Carregando:</p>

  <div class="row">
    <info-card [notices]="[]" [loading]="true" />
  </div>
</section>

<section data-family="navigation">
  <h2 class="gn-headline-xs-bold">Navigation</h2>

  <nav class="tabs">
    <button class="tab tab--active gn-body-md-bold" type="button">Ativo</button>
    <button class="tab gn-body-md-regular" type="button">Inativo</button>
    <button class="tab gn-body-md-regular" type="button">Inativo</button>
  </nav>
</section>

<section data-family="resources">
  <h2 class="gn-headline-xs-bold">Resources</h2>

  <div class="row">
    <article class="card gn-elevation-s">
      <h3 class="gn-body-md-bold">Card com elevation S</h3>
      <p class="gn-body-sm-regular">Superfície primária, borda por token.</p>
    </article>
    <article class="card gn-elevation-m">
      <h3 class="gn-body-md-bold">Card com elevation M</h3>
      <p class="gn-body-sm-regular">Sombra 0 8 16 conforme o dicionário.</p>
    </article>
  </div>
</section>

<section data-family="typography">
  <h2 class="gn-headline-xs-bold">Tipografia</h2>

  <p class="gn-headline-lg-regular">Headline Large 48/64</p>
  <p class="gn-headline-sm-bold">Headline Small Bold 28/40</p>
  <p class="gn-body-md-regular">Body Medium Regular 16/24</p>
  <p class="gn-body-sm-regular">Body Small Regular 14/20</p>
  <p class="gn-body-xs-regular">Body Extra Small Regular 12/16</p>
</section>
